import React, { useEffect } from "react";
import { WithContext as ReactTags } from "react-tag-input";

import './styles.css';
import { Tag } from "react-tag-input/types/components/SingleTag";


export interface ITagInputProps {
    initialTags: Tag[],
    onHandleUpdateTags: any;
}

// Specifies which characters should terminate tags input. An array of character codes.
const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

const InputTag = ( props: ITagInputProps ) => {
  const [tags, setTags] = React.useState<Array<Tag>>(props.initialTags);


  // Method to delete tag from Array
  const handleDelete = (i: any) => {
    setTags(tags.filter((tag, index) => index !== i));
  };

  // Method to Add tag into Array
  const handleAddition = (tag: Tag) => {
    setTags([...tags, tag]);
  };

  // useEffect(() => {
  //   console.log("initial load", tags);
  //   setTags(props.initialTags);
  // }, [props.initialTags]);

  useEffect(() => {
    console.log("use effect called", tags);
    props.onHandleUpdateTags(tags);
  }, [tags]);


  return (
    <div id="tags">
      <ReactTags
        tags={tags}
        delimiters={delimiters}
        handleDelete={handleDelete}
        handleAddition={handleAddition}
        inputFieldPosition="bottom"
        autocomplete
        allowDragDrop={false}
      />
    </div>
  );
};

export default InputTag;